module.exports = __webpack_public_path__ + "static/media/tzt-logo.88e4170f.png";